/* eslint-disable @typescript-eslint/no-explicit-any */
import { AfterContentInit, Directive, ElementRef, Input } from '@angular/core';
import { BUTTON_LOADER_CLASS } from 'core/constants';

export interface PromiseBtnConfig {
    spinnerTpl?: string;
    btnLoadingClass?: boolean | string;
}
@Directive({
    selector: '[promiseBtn]',
    standalone: false
})

export class XmPromiseBtn implements AfterContentInit {
    private btnEl: HTMLElement;
    private promise: Promise<any>;

    private initConfig: PromiseBtnConfig = {
        btnLoadingClass: BUTTON_LOADER_CLASS,
        spinnerTpl: '<span class="btn-loader"><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div></span>'
    };

    constructor(el: ElementRef) {
        this.btnEl = el.nativeElement;
    }

    @Input()
    public set promiseBtn(passedValue: Promise<any>) {
        this.promise = passedValue;
        if (this.promise && this.btnEl) {
            if (typeof this.initConfig.btnLoadingClass === 'string') {
                this.btnEl.classList.add(this.initConfig.btnLoadingClass);
            }
            this.initPromiseHandler();
        }

    }

    public ngAfterContentInit(): void {
        this.btnEl.insertAdjacentHTML('beforeend', this.initConfig.spinnerTpl);
        this.initPromiseHandler();
    }

    private removeLoadingClass(el: HTMLElement): void {
        if (typeof this.initConfig.btnLoadingClass === 'string') {
            el.classList.remove(this.initConfig.btnLoadingClass);
        }
    }

    private initPromiseHandler(): void {
        if (this.promise && this.btnEl) {
            this.promise.then(() => {
                this.removeLoadingClass(this.btnEl);
            }).catch(() => {
                this.removeLoadingClass(this.btnEl);
            });
        }
    }
}